import { Controller } from '@hotwired/stimulus';
import Logger from '../lib/logger';
// Shows only the body rows, of every table inside the element, whose cell in one column reads the value chosen in a
// select. For a table whose own markup cannot carry data attributes: the Audit tab's findings table is generated
// server-side and stored sanitized, which strips them, so the row's category is read from its Category cell instead.
// An empty value shows every row.
class default_1 extends Controller {
    connect() {
        Logger.debug('Controller connected', { controller: this.constructor.name });
    }
    disconnect() {
        Logger.debug('Controller disconnected', { controller: this.constructor.name });
    }
    filter() {
        const chosen = this.hasSelectTarget ? this.selectTarget.value : '';
        this.element.querySelectorAll('table tbody tr').forEach((row) => {
            const cell = row.cells[this.columnValue];
            const shown = chosen === '' || (cell?.textContent ?? '').trim() === chosen;
            row.classList.toggle('d-none', !shown);
        });
    }
}
default_1.targets = ['select'];
default_1.values = { column: { type: Number, default: 0 } };
export default default_1;
